import moment from "moment";
import React, { useState } from "react";
import { useGetTeamsDataQuery } from "../Features/teams/teamsApi";
import AddMember from "../shared/AddMember";
import Navbar from "../shared/Navbar";
import TeamsModal from "../shared/TeamsModal";

const Teams = () => {
    const [modal, setModal] = useState(false);
    const [membarAddModal, setMemberAddModal] = useState(false);
    const [teamId, setTeamId] = useState(null);
    const { data } = useGetTeamsDataQuery();

    const control = () => {
        setModal(!modal);
    };

    const handleMemberAdd = (id) => {
        setMemberAddModal(!membarAddModal);
        setTeamId(id);
    };

    return (
        <div>
            <div className="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200">
                <Navbar />
                <div className="px-10 mt-6 flex justify-between">
                    <h1 className="text-2xl font-bold">Teams</h1>
                    <button
                        className="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
                        onClick={control}
                    >
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            ></path>
                        </svg>
                    </button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-10 mt-4 gap-6 overflow-auto">
                    {data?.map((team) => {
                        return (
                            <div key={team?.id}>
                                <div
                                    className="relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
                                    draggable="true"
                                >
                                    <button
                                        className="absolute top-0 right-0 hover:flex items-center justify-center hidden w-5 h-5 mt-3 mr-2 text-gray-500 rounded hover:bg-gray-200 hover:text-gray-700 group-hover:flex "
                                        onClick={() =>
                                            handleMemberAdd(team?.id)
                                        }
                                    >
                                        <svg
                                            className="w-4 h-4 fill-current"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                        </svg>
                                    </button>
                                    <span
                                        className={`flex items-center h-6 px-3 text-xs font-semibold text-${team?.color}-500 bg-${team?.color}-100 rounded-full`}
                                    >
                                        {team?.name}
                                    </span>
                                    <h4 className="mt-3 text-sm font-medium">
                                        {team?.description}
                                    </h4>
                                    <div className="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                                        <div className="flex items-center">
                                            <svg
                                                className="w-4 h-4 text-gray-300 fill-current"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                            <span className="ml-1 leading-none">
                                                {moment(team?.timestamp).format(
                                                    "ll"
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            {modal && <TeamsModal control={control} modal={modal} />}
            {membarAddModal && (
                <AddMember {...{ setMemberAddModal, membarAddModal, teamId }} />
            )}
        </div>
    );
};

export default Teams;
